<app-section-quick-actions section="realm" />

<header class="atmos-page__header">
  <h1 class="atmos-page__title">Candle Run Tracker</h1>
</header>

<div class="atmos-cr-tracker__container">
  <div class="atmos-cr-tracker__controls">
    <button type="button" class="atmos-btn atmos-btn--sm"
      [skyTooltip]="'Return to Aviary Village'" placement="bottom-start"
      (click)="navigateToArea(defaultArea)">
      <mat-icon>house</mat-icon>
    </button>
    <button type="button" class="atmos-btn atmos-btn--sm"
      [skyTooltip]="'Choose map'" placement="bottom-start"
      (click)="isAreaOverlayVisible.set(true)">
      <mat-icon>globe</mat-icon>
    </button>
    <button type="button" class="atmos-btn atmos-btn--sm"
      [skyTooltip]="'Restart'" placement="bottom-start"
      (click)="promptRestart()">
      <mat-icon>restart_alt</mat-icon>
    </button>
  </div>

  <div class="atmos-cr-tracker__wax">
    {{ waxInAreaFound() }} / {{ waxInArea() }} wax
  </div>

  <div #map id="atmos-cr-map" class="atmos-cr-tracker__map"></div>
</div>

@if (isAreaOverlayVisible()) {
  <app-overlay (close)="isAreaOverlayVisible.set(false)" [title]="'Choose map'">
    <div class="atmos-cr-tracker__overlay">
      <h3 class="atmos-cr-tracker__overlay-section">Maps</h3>
      @for (item of areaOverlayData().areas; track item.area.guid) {
        <button type="button" class="atmos-cr-tracker__overlay-row"
          (click)="navigateToArea(item.area); isAreaOverlayVisible.set(false)">
          <span class="atmos-cr-tracker__overlay-name">{{ item.area.name }}</span>
          @let completed = item.found === item.total;
          <span class="atmos-cr-tracker__overlay-wax" [class.is-complete]="completed">
            {{ item.found }} / {{ item.total }}
          </span>
        </button>
      }

      <h3 class="atmos-cr-tracker__overlay-section">Total</h3>
      <span class="atmos-cr-tracker__overlay-name">All maps</span>
      <span class="atmos-cr-tracker__overlay-wax"
        [class.is-complete]="areaOverlayData().total.found === areaOverlayData().total.total">
        {{ areaOverlayData().total.found }} / {{ areaOverlayData().total.total }}
      </span>
    </div>
  </app-overlay>
}
